import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { ConfigContextProvider } from './context/ConfigContextProvider.tsx';
import { ThemeModeProvider } from './context/ThemeModeProvider.tsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ConfigContextProvider>
      <ThemeModeProvider>
        <App />
      </ThemeModeProvider>
    </ConfigContextProvider>
  </React.StrictMode>
);
